import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.jira',
		defaultMessage: 'Jira',
		description: 'The link label for Jira',
	},
});
